module.exports = __webpack_public_path__ + "static/registerBermudaEn.3b2a31d6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/templates/assets/registerBermudaEn.gif
// module id = 1001
// module chunks = 101932004231744